<template>
  <el-dialog
    title="删除确认"
    :visible.sync="visible"
    width="30%"
    @close="handleClose">
    <p>确认删除该轮播图？删除后不可恢复。</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteWechatAdvert } from '@/api/admin/wechatAdvertApi'

export default {
  name: 'DeleteWechatAdvert',
  data() {
    return {
      visible: false,
      wechatAdvertId: ''
    }
  },
  methods: {
    open(row) {
      this.wechatAdvertId = row.wechatAdvertId
      this.visible = true
    },
    handleClose() {
      this.wechatAdvertId = ''
    },
    async handleConfirm() {
      try {
        await deleteWechatAdvert(this.wechatAdvertId)
        this.$message.success('删除成功')
        this.$emit('success')
        this.visible = false
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    }
  }
}
</script>
